export class BasePathConfig {
  basePath?: string
}
